import StepWrapper from 'components/common/StepWrapper';
import useRfidRegister from 'hooks/useRfidRegister';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { useRfidStore } from 'stores/rfidStore';
import { StyledImage } from 'styles/ContainerStyles';
import { useUiStore } from 'stores/uiStore';

const ReadingTagImage: React.FC<{ testID?: string }> = ({ testID }) => (
  <StyledImage
    source={require('assets/images/scan-tag.png')}
    width={300}
    height={160}
    center
    testID={testID}
  />
);

const RfidStartScanModal: React.FC = () => {
  const { t } = useTranslation();
  const [isDoneScanning, setIsDoneScanning] = useState(false);
  const [showTimeoutError, setShowTimeoutError] = useState(false);
  const serialNumber = useRfidStore(
    (state) => state.rfIdRegistrationSerialNumber
  );
  const currentRfidSocketNumber = useRfidStore(
    (state) => state.rfidSocketNumber
  );
  const { registerRfid } = useRfidRegister();

  useEffect(() => {
    useRfidStore.getState().setCurrentTagName('');
  }, []);

  useEffect(() => {
    const timer = setTimeout(
      () => {
        if (!isDoneScanning) {
          setShowTimeoutError(true);
        }
      },
      2 * 60 * 1000
    );

    return () => {
      clearTimeout(timer);
    };
  }, [isDoneScanning]);

  useEffect(() => {
    if (serialNumber) {
      const tagNumber = Date.now().toString().slice(-4);
      useRfidStore.getState().setCurrentTagName(`My-tag-${tagNumber}`);
      setIsDoneScanning(true);
      useUiStore.getState().setSheetModal('rfidScanComplete');
    }
  }, [serialNumber]);

  const renderTagScanning = () => (
    <StepWrapper
      progress={100}
      description={t(
        'account.tagsAndCards.registerRfid.tagScanning.description'
      )}
      illustration={<ReadingTagImage testID="reading-tag-image" />}
      primaryButton={{
        text: showTimeoutError
          ? t('account.tagsAndCards.registerRfid.tagScanning.tryAgain')
          : t('account.tagsAndCards.registerRfid.tagScanning.readingTag'),
        disabled: !isDoneScanning && !showTimeoutError,
        loading: !isDoneScanning && !showTimeoutError,
        onPress: () => {
          if (showTimeoutError) {
            // Send api/register again
            registerRfid({
              variables: {
                input: {
                  publicDisplayId: currentRfidSocketNumber,
                },
              },
            });
            setShowTimeoutError(false);
          }
        },
        testID: 'reading-tag-button',
      }}
      secondaryButton={
        showTimeoutError
          ? {
              text: t(
                'account.tagsAndCards.registerRfid.tagScanning.changeSocket'
              ),
              onPress: () => {
                useUiStore.getState().setSheetModal('rfidRegister');
              },
              testID: 'scan-again-button',
            }
          : undefined
      }
      errorMessage={
        showTimeoutError
          ? t('account.tagsAndCards.registerRfid.tagScanning.error', {
              socketNumber: currentRfidSocketNumber,
            })
          : undefined
      }
    />
  );

  return <View>{renderTagScanning()}</View>;
};

export default RfidStartScanModal;
